import { createSessionStore } from '@dawn/session-web';

import type { User } from '@/lib/api';

/**
 * The dashboard's session store — the shared @dawn/session-web state machine
 * instantiated over the dashboard's admin principal.
 */
export const useSessionStore = createSessionStore<User>();

// DEV-only: expose the store on window so test-mode bypass can inject a mock
// session without going through the real auth flow. Stripped in production.
if (import.meta.env.DEV) {
  (window as unknown as { __sessionStore?: typeof useSessionStore }).__sessionStore =
    useSessionStore;
}
